import { defineStore } from 'pinia'

export const useTranslationsStore = defineStore('TranslationsStore', {
  state: () => ({
    translations: null,
  }),
  getters: {
    getTranslations: state => {
      if (!state.translations) {
        // try to load from local storage
        const storedTranslations = localStorage.getItem('translations')
        if (storedTranslations) {
          return JSON.parse(storedTranslations)
        } else return []
      } else {
        return toRaw(state.translations)
      }
    },
  },
  actions: {
    async fetchTranslations() {
      try {
        const { $config } = useNuxtApp()
        const url = `/translations`

        const baseUrl = $config.public.BACKEND_URL + ($config.public.BACKEND_URL.at(-1) === '/' ? '' : '/')

        const data = await $fetch(url, {
          method: 'get',
          baseURL: `${baseUrl}api`,
          timeout: 45000,
          retry: 3,
          retryDelay: 2000,
        })

        this.translations = toRaw(data)

        // save to local storage (in case the server is not accessible)
        localStorage.setItem('translations', JSON.stringify(this.translations))

        return this.translations
      } catch (error) {
        console.error(error)

        return null
      }
    },
  },
})
